import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck, FaCogs, FaChartLine, FaHandshake, FaShieldAlt, FaHeadset } from 'react-icons/fa';

const services = [
  {
    icon: <FaTruck />,
    title: 'Transport & Logistique',
    description: 'Solutions de transport optimisées et gestion logistique intégrée pour vos marchandises.'
  },
  {
    icon: <FaCogs />,
    title: 'Gestion Administrative',
    description: 'Accompagnement complet dans vos démarches administratives et réglementaires.'
  },
  {
    icon: <FaChartLine />,
    title: 'Conseil Stratégique',
    description: 'Expertise et conseils personnalisés pour optimiser votre activité professionnelle.'
  },
  {
    icon: <FaHandshake />,
    title: 'Partenariats',
    description: 'Développement de relations commerciales durables et réseau de partenaires fiables.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Conformité & Réglementation',
    description: 'Assurance de conformité aux normes et réglementations en vigueur.'
  },
  {
    icon: <FaHeadset />,
    title: 'Support Client',
    description: 'Accompagnement personnalisé et support réactif pour tous vos besoins.'
  }
];

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Nos Services</h2>
          <p>Des solutions complètes pour accompagner votre entreprise</p>
        </motion.div>
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
